import SvgInline from '@latitude/svg-inline';

export default SvgInline;
